import clsx from "clsx";
import { memo, useMemo } from "react";

import classes from "./styles.module.scss";

import { HeaderTab } from "@components/atoms/headerTab";
import type { IHeaderTabGroupProps } from "@components/molecules/headerTabGroup/types";

export const HeaderTabGroup = memo(function HeaderTabGroup({
  tabs,
  selectedKey,
  onChange,
  tabsSize,
  className,
}: IHeaderTabGroupProps) {
  const tabsComponent = useMemo(
    () =>
      tabs?.map(({ key, title }) => {
        return (
          <HeaderTab
            title={title}
            key={key}
            isSelected={key === selectedKey}
            onSelect={(isSelected) => {
              if (isSelected) onChange(key);
            }}
            size={tabsSize}
          />
        );
      }),
    [onChange, selectedKey, tabs, tabsSize],
  );

  return <div className={clsx(classes.tabs, className)}>{tabsComponent}</div>;
});
